import React from 'react'
import { useI18n } from '../../../i18n'

type Loc = { en?: string; ru?: string; es?: string }

type Props = {
  localization?: Loc
  lang: 'en' | 'ru' | 'es'
}

function pick(loc: Loc | undefined, lang: string) {
  if (!loc) return ''
  return String(loc[lang as keyof Loc] || loc.en || '')
}

export function ControlRecommendationsPanel({ localization, lang }: Props) {
  const { t } = useI18n()
  const text = pick(localization, lang)
  if (!text) return null
  return <p className="text-sm leading-relaxed text-slate-700">{text}</p>
}
